export default __webpack_public_path__ + "static/media/1918.98b20e9d.png";